import { Slide } from "react-reveal";

const NetworkingOffers = () => {
  return (
    <section className="solution-item-section section-spacing-50 world-bg">
      <div className="container">
        <div className="large">
          <div className="section-content-container">
            <div className="solution-offers-container flex">
              <div className="solution-offers-textside">
                <div className="section-head width-600 section-spacing-40 no-padding-top">
                  <p className="section-tag boldTitle">OFFERS</p>
                  <Slide top>
                    <h2 className="section-title ntuna-text-fill">
                      What's Included
                    </h2>
                  </Slide>
                  <p className="section-subtitle font-inter-regular">
                    Because your network is the backbone of your digital
                    operations, we don't just install routers and cables - we
                    design structured, scalable and reliable network systems
                    that support your home, work operations and communications.
                  </p>
                </div>
                <div className="section-body">
                  <ul className="offers-list-container">
                    <li className="offers-list">
                      <h3>Network Needs Assessments & Site Survey</h3>
                      <ul>
                        <li>
                          <span>
                            Physical site inspection (offices, floors,
                            buildings, compounds)
                          </span>
                        </li>
                        <li>
                          <span>
                            Layout analysis (walls, partitions, floors,
                            materials affecting signal)
                          </span>
                        </li>
                        <li>
                          <span>
                            User and device mapping (staff, departments, IoT
                            devices, systems)
                          </span>
                        </li>
                        <li>
                          <span>
                            Bandwidth requirement analysis (per user, per
                            system)
                          </span>
                        </li>
                        <li>
                          <span>
                            Identification of interference sources (metal,
                            competing signals, electrical noise)
                          </span>
                        </li>
                        <li>
                          <span>
                            Coverage planning (WiFi zones, indoor/outdoor areas)
                          </span>
                        </li>
                        <li>
                          <span>
                            Internet usage profiling (heavy usage, streaming,
                            systems, cloud apps)
                          </span>
                        </li>
                        <li>
                          <span>Future expansion considerations</span>
                        </li>
                      </ul>
                    </li>
                    <li className="offers-list">
                      <h3>Network Architecture & System Design</h3>
                      <ul>
                        <li>
                          <span>LAN/WAN architecture design</span>
                        </li>
                        <li>
                          <span>Wired vs wireless optimization strategy</span>
                        </li>
                        <li>
                          <span>
                            Hierarchical network design (core, distribution,
                            access layers)
                          </span>
                        </li>
                        <li>
                          <span>VLAN and network segmentation planning</span>
                        </li>
                        <li>
                          <span>
                            IP addressing scheme (static/dynamic allocation)
                          </span>
                        </li>
                        <li>
                          <span>
                            Redundancy and failover design (where required)
                          </span>
                        </li>
                        <li>
                          <span>
                            Device placement (routers, switches, access points)
                          </span>
                        </li>
                        <li>
                          <span>Scalability planning for growth</span>
                        </li>
                      </ul>
                    </li>
                    <li className="offers-list">
                      <h3>Structured Cabling Infrastructure</h3>
                      <ul>
                        <li>
                          <span>
                            Installation of Cat6 / Cat6a / Fiber cabling
                          </span>
                        </li>
                        <li>
                          <span>
                            Cable routing (concealed or trunked professionally)
                          </span>
                        </li>
                        <li>
                          <span>
                            Patch panel installation and configuration
                          </span>
                        </li>
                        <li>
                          <span>Wall outlets and network points</span>
                        </li>
                        <li>
                          <span>
                            Labeling and documentation of all network lines
                          </span>
                        </li>
                        <li>
                          <span>Rack setup and cable organization</span>
                        </li>
                        <li>
                          <span>
                            Separation of power and data lines to reduce
                            interference
                          </span>
                        </li>
                      </ul>
                    </li>
                    <li className="offers-list">
                      <h3>Wifi Network Design & Deployment</h3>
                      <ul>
                        <li>
                          <span>Access point selection and placement</span>
                        </li>
                        <li>
                          <span>Signal strength planning and heat mapping</span>
                        </li>
                        <li>
                          <span>Elimination of dead zones</span>
                        </li>
                        <li>
                          <span>Multi-floor and large-area WiFi design</span>
                        </li>
                        <li>
                          <span>Load balancing across access points</span>
                        </li>
                        <li>
                          <span>Frequency/channel optimization</span>
                        </li>
                        <li>
                          <span>
                            Secure SSID configuration (staff, guest, admin
                            networks)
                          </span>
                        </li>
                      </ul>
                    </li>
                    <li className="offers-list">
                      <h3>Core Network Devices Configuration</h3>
                      <ul>
                        <li>
                          <span>
                            Router configuration (routing, NAT, firewall basics)
                          </span>
                        </li>
                        <li>
                          <span>Managed/unmanaged switch setup</span>
                        </li>
                        <li>
                          <span>
                            VLAN configuration for traffic segmentation
                          </span>
                        </li>
                        <li>
                          <span>
                            Quality of Service (QoS) for prioritizing critical
                            applications
                          </span>
                        </li>
                        <li>
                          <span>Traffic routing optimization</span>
                        </li>
                      </ul>
                    </li>
                    <li className="offers-list">
                      <h3>Internet Integration & Bandwidth Management</h3>
                      <ul>
                        <li>
                          <span>ISP integration and configuration</span>
                        </li>
                        <li>
                          <span>
                            Multi-ISP setup (load balancing / failover)
                          </span>
                        </li>
                        <li>
                          <span>
                            Bandwidth allocation per user or department
                          </span>
                        </li>
                        <li>
                          <span>Speed optimization</span>
                        </li>
                        <li>
                          <span>Traffic shaping and prioritization</span>
                        </li>
                      </ul>
                    </li>
                    <li className="offers-list">
                      <h3>Network Security & Access Control</h3>
                      <ul>
                        <li>
                          <span>Firewall setup and configuration</span>
                        </li>
                        <li>
                          <span>Secure WiFi encryption (WPA2/WPA3)</span>
                        </li>
                        <li>
                          <span>Guest network isolation</span>
                        </li>
                        <li>
                          <span>Device access restrictions</span>
                        </li>
                        <li>
                          <span>Port security and monitoring</span>
                        </li>
                        <li>
                          <span>Protection against unauthorized access</span>
                        </li>
                      </ul>
                    </li>
                    <li className="offers-list">
                      <h3>Device Connectivity & System Integration</h3>
                      <ul>
                        <li>
                          <span>Workstations and laptops</span>
                        </li>
                        <li>
                          <span>Printers and shared devices</span>
                        </li>
                        <li>
                          <span>Servers and cloud systems</span>
                        </li>
                        <li>
                          <span>CCTV and access control systems</span>
                        </li>
                        <li>
                          <span>POS systems and business applications</span>
                        </li>
                      </ul>
                    </li>
                    <li className="offers-list">
                      <h3>Network Testing, Optimization & Validation</h3>
                      <ul>
                        <li>
                          <span>Speed testing (LAN and internet)</span>
                        </li>
                        <li>
                          <span>Signal strength testing</span>
                        </li>
                        <li>
                          <span>Load and stress testing</span>
                        </li>
                        <li>
                          <span>Latency and performance checks</span>
                        </li>
                        <li>
                          <span>Troubleshooting and fine-tuning</span>
                        </li>
                      </ul>
                    </li>
                    <li className="offers-list">
                      <h3>User Access Control & Network Management</h3>
                      <ul>
                        <li>
                          <span>User roles and permissions</span>
                        </li>
                        <li>
                          <span>Department-based segmentation</span>
                        </li>
                        <li>
                          <span>Admin access setup</span>
                        </li>
                        <li>
                          <span>Network monitoring configuration</span>
                        </li>
                        <li>
                          <span>Design improvements over time</span>
                        </li>
                      </ul>
                    </li>
                    <li className="offers-list">
                      <h3>Documentation & System Handover</h3>
                      <ul>
                        <li>
                          <span>Network layout documentation</span>
                        </li>
                        <li>
                          <span>Device configurations record</span>
                        </li>
                        <li>
                          <span>Access credentials management</span>
                        </li>
                        <li>
                          <span>System usage guidelines</span>
                        </li>
                      </ul>
                    </li>
                    <li className="offers-list">
                      <h3>Maintenance, Support & Performance Management</h3>
                      <ul>
                        <li>
                          <span>Preventive maintenance</span>
                        </li>
                        <li>
                          <span>Network health monitoring</span>
                        </li>
                        <li>
                          <span>Performance optimization</span>
                        </li>
                        <li>
                          <span>Issue diagnosis and resolution</span>
                        </li>
                        <li>
                          <span>Remote or on-site support</span>
                        </li>
                      </ul>
                    </li>
                    <li className="offers-list">
                      <h3>Scalable & Future Ready Network Design</h3>
                      <ul>
                        <li>
                          <span>Expandable infrastructure</span>
                        </li>
                        <li>
                          <span>Upgrade-ready systems</span>
                        </li>
                        <li>
                          <span>Modular network design</span>
                        </li>
                        <li>
                          <span>
                            Integration readiness for future technologies
                          </span>
                        </li>
                      </ul>
                    </li>
                    <li className="offers-list">
                      <h3>High-density & Specialized Environments Support</h3>
                      <ul>
                        <li>
                          <span>Office clusters and co-working spaces</span>
                        </li>
                        <li>
                          <span>Schools and computer labs</span>
                        </li>
                        <li>
                          <span>Hotels and public WiFi environments</span>
                        </li>
                        <li>
                          <span>Event or high-user-density setups</span>
                        </li>
                      </ul>
                    </li>
                    <li className="offers-list">
                      <h3>Use Cases</h3>
                      <ul>
                        <li>
                          <span>Offices & corporate environments</span>
                        </li>
                        <li>
                          <span>Schools & ICT labs</span>
                        </li>
                        <li>
                          <span>Hotels & hospitality spaces</span>
                        </li>
                        <li>
                          <span>Retail & commercial setups</span>
                        </li>
                        <li>
                          <span>Homes & residential estates</span>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default NetworkingOffers;
